// extracted by mini-css-extract-plugin
export default {"products":"home_products__iPYVM","product-container":"home_product-container__k7a0Z","btn-view-all-container":"home_btn-view-all-container__H-YnC","btn":"home_btn__jajsi"};